/* tslint:disable */

declare var Object: any;
export interface CityInterface {
  "seo_id": string;
  "name": string;
  "state": any;
  "cbsa"?: string;
  "point": any;
  "population": number;
  "id"?: any;
}

export class City implements CityInterface {
  "seo_id": string;
  "name": string;
  "state": any;
  "cbsa": string;
  "point": any;
  "population": number;
  "id": any;
  constructor(data?: CityInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `City`.
   */
  public static getModelName() {
    return "City";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of City for dynamic purposes.
  **/
  public static factory(data: CityInterface): City{
    return new City(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'City',
      plural: 'Cities',
      properties: {
        "seo_id": {
          name: 'seo_id',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "state": {
          name: 'state',
          type: 'any'
        },
        "cbsa": {
          name: 'cbsa',
          type: 'string'
        },
        "point": {
          name: 'point',
          type: 'any'
        },
        "population": {
          name: 'population',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/City.ts